export default __webpack_public_path__ + "static/media/suitenupcias_4.e5734ad8.jpg";